import EditRow from "../../../components/common/EditRow";
import { SelectTitle } from "@patient-watch/forms";
import OrganisationsRolesTable from "../../organisations/components/OrganisationsRolesTable";
import CompleteProfile from "./CompleteProfile";
import FavouriteUsers from "./FavouriteUsers";
import ProfileProgress from "./ProfileProgress";
import ProfileCallout from "./ProfileCallout";
import SelectFont from "./SelectFont";
import TeamPreviewCard from "./TeamPreviewCard";
import TeamPage from "./TeamPage";
import TeamTable from "./TeamTable";
import TeamMemberDialog from "./TeamMemberDialog";

export const profileComponents = {
    ProfileProgress,
    ProfileCallout,
    ProfileRow: EditRow,
    SelectTitle,
    OrganisationsRoles: OrganisationsRolesTable,
    CompleteProfile,
    FavouriteUsers,
    SelectFont,
    TeamPreviewCard,
    TeamPage,
    TeamTable,
    TeamMemberDialog,
};
